
export enum NotificationType{
    Synergies = -1,
    Chat = -2,
    System = -3,
    Document = -4,
    Event = -5,
    Forum = -6,
    Default = 0,
}